"use client";

import { useOpenApiMutation } from "../../request/hooks/openApi/useOpenApiMutation";

export const useOnboardingSettings = () => ({
  mutationPostOnboardingSmsMarketingOptIn: useOpenApiMutation({
    method: "POST",
    urlBackendPath: "/onboarding/sms-marketing-opt-in",
  }),
});
